import type { FuelProjectionState } from "../hooks/useFuelProjection";

const DANGER_LAPS = 3;

interface FuelChipProps {
  fuel: FuelProjectionState;
}

export function FuelChip({ fuel }: FuelChipProps) {
  const { fuelLevel, lapsRemaining, minutesRemaining } = fuel;
  const danger = lapsRemaining !== null && lapsRemaining < DANGER_LAPS;
  const parts = [
    fuelLevel !== null ? `${Math.round(fuelLevel)}%` : "—",
    lapsRemaining !== null ? `~${lapsRemaining} laps` : null,
    minutesRemaining !== null ? `~${minutesRemaining} min` : null,
  ].filter((part): part is string => part !== null);

  return (
    <div
      className={`gauge-chip fuel-chip${danger ? " fuel-chip--danger" : ""}`}
      data-testid="fuel-chip"
      title={
        lapsRemaining === null
          ? "Fuel projection needs two laps of observed burn"
          : "Fuel level · projected laps · projected minutes at recent pace"
      }
    >
      <span className="gauge-chip__label">FUEL</span>
      <span className="gauge-chip__value">{parts.join(" · ")}</span>
    </div>
  );
}
